module.exports = __webpack_public_path__ + "si.svg?a6c3b9539ecbf7e144fd9c6769cd5b77";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/si.svg
// module id = 1182
// module chunks = 27